var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-group col-12"},[_c('label',[_vm._v("Pdf")]),_c('media-chooser',{attrs:{"value":_vm.pdf,"type":"pdf"},on:{"input":_vm.onPdfChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }